import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";

const URL_RE = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

function Linkified({ text }) {
  return text.split(URL_RE).map((part, i) =>
    URL_RE.test(part) || part.startsWith("www.")
      ? <a key={i} href={part.startsWith("http") ? part : `https://${part}`} target="_blank" rel="noopener noreferrer" className="underline text-[#7FDCE6] break-all">{part}</a>
      : <span key={i}>{part}</span>);
}

export function CallChat({ chat, sendChat }) {
  const [text, setText] = useState("");
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ block: "nearest" }); }, [chat.length]);
  const submit = (e) => { e.preventDefault(); sendChat(text); setText(""); };
  return (
    <div className="flex flex-col border-t border-white/10 min-h-0" data-testid="call-chat">
      <div className="flex-1 overflow-y-auto px-3 py-2 flex flex-col gap-1.5 max-h-48 lg:max-h-none" data-testid="call-chat-messages">
        {chat.length === 0 && <p className="text-[11px] text-white/40">Send messages and links during the call.</p>}
        {chat.map((m, i) => (
          <p key={i} className={`max-w-[85%] rounded-xl px-3 py-1.5 text-xs whitespace-pre-wrap break-words ${m.me ? "self-end bg-[#1A9AA8] text-white" : "self-start bg-white/10 text-[#F5ECD7]"}`} data-testid="call-chat-message"><Linkified text={m.text} /></p>
        ))}
        <span ref={end} />
      </div>
      <form onSubmit={submit} className="flex gap-2 p-2">
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Message or paste a link..." maxLength={2000}
          className="flex-1 min-w-0 rounded-lg bg-white/10 text-white placeholder:text-white/40 px-3 py-2 text-xs outline-none focus:ring-1 focus:ring-[#1A9AA8]" data-testid="call-chat-input" />
        <button disabled={!text.trim()} className="rounded-lg bg-[#F08A3C] text-white px-3 disabled:opacity-40" aria-label="Send" data-testid="call-chat-send"><Send className="h-4 w-4" /></button>
      </form>
    </div>
  );
}
